import { Button, Stack, Typography } from '@mui/material'
import { forwardRef } from 'react'
import { TextInputField, TextInputFieldProps } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type ButtonCellProps = {
  loading: boolean
  disabled: boolean
  onSubmit: () => void
}
export const ButtonCell: Cell<ButtonCellProps> = ({
  loading,
  disabled,
  onSubmit,
}) => {
  const { t } = useTranslation('personalInfoSettings')
  return (
    <CellFrame sx={{ py: 5, textAlign: 'center' }}>
      <Button
        size="large"
        sx={{ width: 244 }}
        disabled={disabled}
        loading={loading}
        onClick={onSubmit}
      >
        {t('submit')}
      </Button>
    </CellFrame>
  )
}

export const TextInputCell = forwardRef(
  (
    {
      titleProps,
      textFieldProps,
      isRequired,
      error,
      ...props
    }: Omit<TextInputFieldProps, 't'> & { isRequired?: boolean },
    ref
  ) => {
    const { t } = useTranslation('personalInfoSettings')
    return (
      <CellFrame>
        <TextInputField
          titleProps={{
            children: (
              <Stack direction="row" alignItems="center">
                <Typography variant="subtitle1" color="text.secondary">
                  {t(`${props.name}Title`)}
                </Typography>
                {isRequired && (
                  <Typography
                    variant="caption"
                    color="error.main"
                    component="p"
                    ml={1}
                    mt={-1}
                  >
                    {t('required', '※必須')}
                  </Typography>
                )}
              </Stack>
            ),
            ...titleProps,
            variant: 'subtitle1',
            color: 'text.secondary',
          }}
          textFieldProps={{ ...textFieldProps, sx: { mb: 1 } }}
          ref={ref}
          {...props}
          error={error}
          t={t}
        />
      </CellFrame>
    )
  }
)
